module.exports = __webpack_public_path__ + "img/main-logo.690884b0.png";